import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import Grid from '@material-ui/core/Grid'
import TillManagementForm from 'components/hiboutikForms/TillManagementForm'
import FlightTakeoff from '@material-ui/icons/FlightTakeoff'
const styles = theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    width: 50,
    height: 50
  }
})
class StartDayModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    startDay: PropTypes.func.isRequired
  }
  state = {
    okDisabled: true
  }
  handleHiboutikFormClick = e => {
    this.setState({ okDisabled: false })
  }
  handleStartDay = () => {
    this.props.startDay()
  }

  render() {
    const { auth } = this.props
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleStartDay}
        title={`Démarrer la journée`}
        okText={`C'est parti !`}
        showCancel={false}
        okDisabled={this.state.okDisabled}
        showOk>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-around">
          <Grid
            item
            xs={12}
            container
            direction="column"
            alignItems="center"
            justify="flex-start">
            <Grid item>
              <Avatar className={this.props.classes.avatar}>
                <FlightTakeoff color="inherit" />
              </Avatar>
            </Grid>
            <Grid item>
              <Typography variant="subheading" noWrap>
                {' '}
                Démarrer la journée{' '}
              </Typography>
            </Grid>
            <Grid item>
              <TillManagementForm
                onClick={this.handleHiboutikFormClick}
                hiboutikAccount={auth.hiboutikAccount}
              />
            </Grid>
            <Grid item>
              <Typography variant="caption" gutterBottom>
                Une fois la vérification effectuée sur Hiboutik, cliquez sur
                'C'est Parti !'
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(StartDayModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/StartDayModal.js